import React from 'react';
import { Box, Typography } from '@mui/joy';

export default function NoPermission() {


  return (

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            minHeight: 'calc(100vh - 64px)',
          }}
        >
          <img
            src="/img/401.png"
            alt="Pagina non trovata"
            style={{ maxWidth: '400px', marginBottom: '2rem' }}
          />
          <Typography level="h2">401 - Permessi insufficenti</Typography>
          <Typography level="body-md" sx={{ mt: 1 }}>
            Non hai abbastanta permessi per accedere a questa pagina          </Typography>
        </Box>
  );
}
